import { get, put, post, del } from 'lib/API';

export const deleteUserProfile = async (
  [profileId]: any,
  { token }: any
) => {
  return await del(`v1/user-profile/${profileId}`, token);
}

export const deleteBulkUserProfile = async (
  [profileIds]: any,
  { token }: any
) => {
  return await put(`v1/user-profile/bulk/delete`, token, { profileIds });
}

export const updateUserProfile = async (
  [profileId, updatedData]: any,
  { token }: any
) => {
  return await put(`v1/user-profile/${profileId}`, token, updatedData);
}